.columnas {
  display: flex;
  gap: var(--s-8);
  align-items: flex-start;
}
.lista {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-6);
}
.tarjetas {
  display: flex;
  flex-direction: column;
  gap: var(--s-6);
}
.tarjetas[aria-busy="true"] {
  opacity: 0.7;
  transition: opacity var(--dur-fast) var(--ease-standard);
}
.lateral {
  width: 296px;
  flex: none;
  display: flex;
  flex-direction: column;
  gap: var(--s-6);
  position: sticky;
  top: var(--s-8);
}
.cabecera {
  margin-bottom: var(--s-5);
}
.kpis {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-3);
}
.kpi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s-5);
  padding: var(--s-4) var(--s-5);
  border-radius: var(--r-md);
  background: var(--surface-sunken);
}
.kpi dt {
  font-size: var(--fs-3xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  color: var(--text-muted);
}
.kpi dd {
  margin: 0;
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  font-weight: var(--fw-semibold);
  line-height: 1;
  color: var(--text-strong);
  font-variant-numeric: tabular-nums;
}
.preparar {
  display: flex;
  flex-direction: column;
  gap: var(--s-6);
}
.cifra {
  font-family: var(--font-mono);
  color: var(--text-strong);
}
.pasos {
  list-style: none;
  margin: var(--s-6) 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--s-5);
}
.paso {
  display: flex;
  gap: var(--s-5);
  align-items: flex-start;
}
.pasoIcono {
  width: 26px;
  height: 26px;
  flex: none;
  border-radius: var(--r-full);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pasoIcono[data-tono="brand"] { background: var(--surface-brand-soft); color: var(--accent-700); }
.pasoIcono[data-tono="success"] { background: var(--status-success-bg); color: var(--text-success); }
.pasoIcono[data-tono="danger"] { background: var(--status-danger-bg); color: var(--text-danger); }
@media (max-width: 1100px) {
  .columnas { flex-direction: column; }
  .lateral { width: 100%; position: static; }
}
